<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">For my grandparents and the members of their generation who shared with me their stories of sacrifice and endured so that others could prosper.</p><br/>
<p style="text-align: center;">In honor of the over 400 million Indigenous peoples across our world and their stewardship over a wide and diverse range of critical issues that are important to our very existence and survival as a global community.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?4b89540c